import { getLocale } from "../runtime";

const da_noorder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Betalingen kunne ikke indlæses. Sørg for at du har produkter i kurven, og genindlæs siden. Hvis problemet fortsætter, kontakt support.`
};

const en_noorder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Payment could not be loaded. Make sure you have products in your cart and reload the page. If the problem persists, contact support.`
};

const es_noorder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `No se pudo cargar el pago. Asegúrate de tener productos en el carrito y recarga la página. Si el problema persiste, contacta con soporte.`
};

const fi_noorder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Maksua ei voitu ladata. Varmista, että ostoskorissasi on tuotteita ja päivitä sivu. Jos ongelma jatkuu, ota yhteyttä asiakaspalveluun.`
};

const nb_noorder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Betalingen kunne ikke lastes. Sørg for at du har produkter i handlekurven, og last siden på nytt. Hvis problemet vedvarer, kontakt support.`
};

const sv_noorder = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Betalningen kunde inte laddas. Säkerställ att du har produkter i kundvagnen, och ladda om sidan. Om problemet kvarstår, kontakta supporten.`
};

const noorder = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_noorder(inputs)
	if (locale === "en") return en_noorder(inputs)
	if (locale === "es") return es_noorder(inputs)
	if (locale === "fi") return fi_noorder(inputs)
	if (locale === "nb") return nb_noorder(inputs)
	if (locale === "sv") return sv_noorder(inputs)
	return "noOrder";
};

export { noorder as "noOrder" };